import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import notEmpty from '../../core/util/notEmpty';
import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockQuantity,
} from '../types';
import type { UseProductNodeStockAtLocationOptions } from './useProductNodeStockQuantityQuery';
import useProductNodeStockQuantity from './useProductNodeStockQuantityQuery';
import useProductOrderRestrictions from './useProductOrderRestrictions';

const useProductNodeStockAtLocation = (
    skuList: string[],
    location?: string,
    options?: UseProductNodeStockAtLocationOptions
): {
    stock: StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction: ProductOrderRestriction[];
    loading: boolean;
} => {
    const { store } = useStoreAndLanguageParams();

    const { data: restrictionsData, loading: restrictionLoading } =
        useProductOrderRestrictions({
            skuList,
            skip: options?.skip,
        });

    const { data, error, loading } = useProductNodeStockQuantity({
        store,
        skuList,
        stockLocation: location,
        options: { ...options },
    });

    if (
        error &&
        !error.graphQLErrors.find(
            item => item.extensions?.code === 'BUSINESS_LOGIC_ERROR'
        )
    ) {
        throw error;
    }

    if (!data || loading || !restrictionsData || restrictionLoading) {
        return {
            stock: [],
            futureStock: [],
            restriction: [],
            loading: true,
        };
    }

    const futureStock = data.productListFutureStock;
    const stock = data.stockQuantities;
    const restriction = restrictionsData.productListOrderRestriction.filter(
        item => notEmpty(item.restrictionId)
    );

    return { stock, futureStock, restriction, loading };
};

export default useProductNodeStockAtLocation;
